module.exports = __webpack_public_path__ + "assets/img/page4-design-base-dfe6e1e2.jpg";